<template>

    <v-modal title="Duplicate Template" :loading="starting">
        <template #body>
            <v-alert :message="error" />
            <p>Are you sure you want to duplicate:<br>{{ template.name }}</p>
            <v-form-group v-if="projects.length" dir="ver" label="Add to Project">
                <v-select :model="params.project_id" @input="params.project_id = $event">
                    <option v-for="p in projects" :key="p.id" :value="p.id">{{ p.name }}</option>
                </v-select>
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="duplicateTemplate">Duplicate Template</v-button>
        </template>
    </v-modal>

</template>

<script>

import MemberApi from '@api/MemberApi';
import TemplateApi from '@api/TemplateApi';

export default {

    props: {
        template: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            starting: true,
            loading: false,
            error: null,
            projects: [],
            params: {},
        }
    },

    mounted() {
        this.getProjects();
        this.params.project_id = this.project.id;
    },

    methods: {

        getProjects() {
            MemberApi.getProjects(this.$store.getters.user.member.id)
                .then((response) => {
                    this.starting = false;
                    this.projects = response.data.data;
                }, () => {
                    this.starting = false;
                });
        },

        duplicateTemplate() {
            this.loading = true;
            TemplateApi.duplicateTemplate(this.template.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.duplicated'));
                    this.$emit('duplicated');
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>